<template>
  <popup :show="true" height="680px" width="980px" @on-close="onClose">
    <template v-if="current_pattern.id">
      <div class="fabric-content-wrap">
        <div class="info-wrap">
          <div class="left-popup">
            <div
              v-if="
                current_pattern.image_list &&
                current_pattern.image_list.length > 0
              "
              class="slider"
            >
              <swiper ref="swiper" :options="swiperOption">
                <swiper-slide
                  v-for="(item, index) in current_pattern.image_list"
                  :key="`sl` + index"
                >
                  <img v-viewer :src="item.url" class="f-img" />
                </swiper-slide>
                <div slot="button-prev" class="swiper-button-prev"></div>
                <div slot="button-next" class="swiper-button-next"></div>
              </swiper>
            </div>
          </div>
          <div class="right">
            <p class="name">{{ current_pattern.pattern_number }}</p>
            <!-- category_name -->
            <p class="no">
              类别:<span>{{ current_pattern.category_name }}</span>
            </p>
            <p class="no">
              性别:<span>{{ current_pattern.sex | sex_filter }}</span>
            </p>
            <p class="no">
              面料耗量(米):<span>{{ current_pattern.consumption }}</span>
            </p>
            <p class="no" v-show="current_pattern.consumption2 > 0">
              里料耗量(米):<span>{{ current_pattern.consumption2 }}</span>
            </p>
          </div>
        </div>
        <div class="title-box">
          <div class="title">规格尺寸详情说明</div>
          <div class="line"></div>
        </div>

        <div class="richtext-wrap">
          <div v-html="current_pattern.description"></div>
          <div class="size-list">
            尺码:<span
              v-for="(item, index) in current_pattern.size_list"
              :key="index"
              >{{ item }}</span
            >
          </div>
          <table border="none">
            <thead>
              <tr style="background: #e5e5e5; text-align: center">
                <th style="background: transparent !important">尺码/部位</th>
                <th v-for="part in current_pattern.part_list" :key="part">
                  {{ getPatternName(part) }}
                </th>
              </tr>
            </thead>
            <tbody border="none">
              <tr
                v-for="row in table_data"
                :key="row.size"
                style="text-align: center"
              >
                <td style="width: auto; min-width: 100px; max-width: 150px">
                  {{ row.size }}
                </td>
                <td
                  border="none"
                  v-for="part in current_pattern.part_list"
                  :key="`${row.size}-${part}`"
                  style="width: 100px"
                >
                  <div>
                    {{ row[part] && row[part].normal ? row[part].normal : "-" }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="btn-box">
        <button class="cancel-btn" @click="onClose">取消</button>
        <button class="confirm-btn" @click="onCreateDesign">创建款式设计</button>
      </div>
    </template>
    <template v-else>
      <div class="custom-fabric-detail">
        <div class="title">版型详情</div>
        <div class="detail-body" v-if="current_pattern">
          <div class="container">
            <div class="main-file">
              <div class="file-container">
                <div class="file-left">
                  <img
                    :src="
                      (current_pattern && current_pattern.path
                        ? util.get_image_icon(current_pattern.path)
                        : '') | default_img(false)
                    "
                    alt=""
                    class="file-ico"
                  />
                  <div class="file-name-box">
                    <div class="name">{{ current_pattern.name }}</div>
                    <div class="type">客供版型</div>
                  </div>
                </div>
                <div
                  class="down-btn"
                  @click="onDownloadFile({path: current_pattern.path, name: current_pattern.name})"
                ></div>
              </div>
            </div>
            <div class="main-info">
              <div class="info-item">
                <div class="info-label">适用性别:</div>
                <div class="info-value">
                  {{ current_pattern.sex }}
                  <!-- {{ current_pattern.sex | sex_filter }} -->
                </div>
              </div>
              <div class="info-item">
                <div class="info-label">面料耗量(M):</div>
                <div class="info-value">
                  {{ current_pattern.consumption || "0" }}
                </div>
              </div>
              <div class="info-item">
                <div class="info-label">里料耗量(M):</div>
                <div class="info-value">
                  {{ current_pattern.consumption2 || "0" }}
                </div>
              </div>
            </div>
            <div class="part-title">
              <div class="title-name">规格表</div>
              <div class="title-line"></div>
            </div>
            <div
              class="file-list-box"
              v-if="
                current_pattern &&
                current_pattern.guige_name &&
                current_pattern.guige_path
              "
            >
              <div
                class="file-list-item"
                v-for="(item, index) in [current_pattern]"
                :key="index"
              >
                <div class="list-item-container">
                  <div class="list-item-left">
                    <!-- {{ item.guige_path }} -->
                    <img
                      :src="
                        (item.guige_path
                          ? util.test_image(item.guige_path) ? item.guige_path :util.get_image_icon(item.guige_path)
                          : '') | default_img
                      "
                      alt=""
                      class="item-file-icon"
                    />
                    <div class="item-file-name">{{ item.guige_name }}</div>
                  </div>
                  <div
                    class="list-item-right"
                    @click="onDownloadFile({path: item.guige_path, name: item.guige_name})"
                  >
                    下载
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-box">
          <button class="cancel-btn" @click="onClose">取消</button>
          <button class="confirm-btn" @click="onCreateDesign">创建款式设计</button>
        </div>
      </div>
    </template>
  </popup>
</template>
<script>
import Popup from "@/components/Popup.vue";
import util from "@/utils/util";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "PatternDetail",
  components: {
    Popup,
    swiper,
    swiperSlide,
  },
  props: {
    pattern: {
      type: Object,
      default: () => {
        return {
          image_list: [],
          field_list: [],
        };
      },
    },
  },
  data() {
    return {
      util,
      swiperOption: {
        loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      },
      current_pattern: {
        image_list: [],
        field_list: [],
      },
      table_data: [],
    };
  },
  mounted() {
    console.log('this.pattern',this.pattern);
    this.current_pattern = this.pattern;
  },
  methods: {
    async onDownloadFile(file) {
      console.log('file',file);
      try {
        if(!file.path){
          this.$layer.msg('无可下载文件');
          return;
        }
        const response = await fetch(file.path);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        const fileName = file.name || file.path.split('/').pop().split('?')[0] || 'download';
        link.download = decodeURIComponent(fileName);

        link.style.display = 'none';
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载文件时出错:', error);
        this.$layer.msg('下载失败，请稍后重试');
      }
    },
    onCreateDesign() {
      console.log("创建款式----", this.current_pattern);
      
      // 保存版型数据到 localStorage，以便在设计页面使用
      localStorage.setItem('selected_pattern', JSON.stringify(this.current_pattern));
      
      // 跳转到设计页面
      this.$router.push({ 
        name: 'WorkBenchDesign',
        params: {
          file: {
            type: '51' // 标识为版型类型
          }
        }
      });
      
      // 关闭当前弹窗
      this.onClose();
    },
    getPatternName(field_key) {
      const { field_list } = this.current_pattern;
      console.log('field_list',field_list);
      
      const data = field_list.find((item) => item.field_key === field_key);
      console.log("data====>", data);
      return data ? data.field_name_cn : "";
    },
    generateTableData(partList, sizeList, sizeInfo) {
      const result = [];

      // 添加校验：确保 sizeList 是一个非空数组
      if (!Array.isArray(sizeList) || sizeList.length === 0) {
        return result; // 返回空数组，避免报错
      }

      for (const sizeKey of sizeList) {
        let size = "";

        // 处理不同类型的 sizeKey
        if (typeof sizeKey === "string") {
          // 如果是字符串，例如 "XL"
          size = sizeKey;
        } else if (typeof sizeKey === "number") {
          // 如果是数字，例如 35, 36
          size = String(sizeKey); // 转换为字符串
        } else if (Array.isArray(sizeKey)) {
          // 如果是数组，例如 ["XL"]
          size = String(sizeKey[0]);
        } else if (typeof sizeKey === "object" && sizeKey !== null) {
          // 如果是对象，例如 { key: "XL" }
          const keys = Object.keys(sizeKey);
          if (keys.length > 0) {
            size = String(keys[0]); // 使用第一个键作为 size 名称
          }
        } else {
          console.warn("Unexpected sizeKey type:", typeof sizeKey, sizeKey);
          continue;
        }

        const sizeData = sizeInfo[size];

        const row = {
          size: size,
        };

        for (const part of partList) {
          if (sizeData && sizeData[part]) {
            row[part] = {
              normal: sizeData[part].normal,
              min: sizeData[part].min,
              max: sizeData[part].max,
            };
          } else {
            row[part] = {
              normal: "",
              min: "",
              max: "",
            };
          }
        }

        result.push(row);
      }

      return result;
    },
    onPatternDetail(pattern) {
      this.table_data = this.generateTableData(
        pattern.part_list || pattern.fullPat.part_list,
        pattern.size_list || pattern.fullPat.size_list,
        pattern.size_info || pattern.fullPat.size_info
      );
      console.log(this.table_data, "<===tableData");
    },
    onClose() {
      this.$emit("on-close");
    },
  },
};
</script>

<style lang="scss" scoped>
.fabric-content-wrap {
  margin-top: 40px;
  overflow-y: scroll;
  height: 600px;

  .title-box {
    display: flex;
    align-items: center;
    column-gap: 13px;
    .title {
      color: #1a1a1a;
      font-size: 16px;
      border-left: none;
      font-weight: bold;
      margin-bottom: 0;
      padding: 10px 0;
      height: auto;
    }
    .line {
      flex: 1;
      height: 1px;
      background: #ebebeb;
    }
  }

  .info-wrap {
    display: flex;
    justify-content: space-around;

    .left-popup {
      width: 420px;
      border: 1px solid #e5e5e5;
      .f-img {
        width: 420px;
        height: 420px;
        object-fit: contain;
      }
    }

    .right {
      width: 500px;
      padding-right: 20px;
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      .name {
        color: #1a1a1a;
        font-size: 20px;
        padding-bottom: 18px;
        width: 100%;
        border-bottom: 1px solid #ebebeb;
      }

      .no {
        color: #808080;
        font-size: 14px;
        margin: 25px 0;
        width: 100%;
        span {
          color: #1a1a1a;
          font-size: 14px;
        }
      }

      .item {
        margin: 5px 0;

        .key {
          display: inline-block;
          color: #808080;
          width: 80px;
        }

        .value {
          color: #1a1a1a;
        }
      }
    }
  }

  .richtext-wrap {
    padding: 0 0 15px 0;
    .size-list {
      display: flex;
      align-items: center;
      column-gap: 5px;
      margin-bottom: 10px;
      span {
        background: rgb(237, 245, 254);
        border: 1px solid rgb(230, 241, 253);
        color: rgb(143, 198, 248);
        border-radius: 5px;
        padding: 3px 5px;
      }
    }
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
    }

    th,
    td {
      border: 1px solid #ddd;
      padding: 8px;
    }

    th:first-child,
    td:first-child {
      position: sticky;
      left: 0;
      background: white;
      z-index: 1;
      box-shadow: 1px 0 0 #ccc; /* 添加视觉分隔 */
    }
  }
}
.btn-box {
  display: flex;
  justify-content: center;
  column-gap: 20px;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background: #ffffff;
  padding: 10px 0;
  .cancel-btn {
    width: 120px;
    height: 38px;
    border-radius: 19px;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    color: #1a1a1a;
    font-size: 14px;
    cursor: pointer;
  }
  .confirm-btn {
    width: 120px;
    height: 38px;
    border-radius: 19px;
    background: #1a1a1a;
    color: #ffffff;
    font-size: 14px;
    cursor: pointer;
  }
}

.slider {
  width: 420px;
  height: 420px;
  overflow: hidden;

  .swiper-slide {
    width: 420px;
    height: 420px;
  }

  .img {
    width: 420px;
    height: 420px;
    object-fit: contain;
  }
}

.custom-fabric-detail {
  overflow-y: scroll;
  width: 100%;
  // height:100%;
  // min-height:600px;
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  &::-webkit-scrollbar{
    display:none;
  }
  .title {
    width: 100%;
    border-bottom: 1px solid #e0e0e0;
    font-weight: bold;
    color: #1a1a1a;
    font-size: 20px;
    padding: 20px 30px;
    position: sticky;
    top: 0;
    z-index: 1;
    background: #ffffff;
    flex-shrink: 0;
  }
  .detail-body {
    width: 100%;
    flex: 1;
    overflow-y: auto;
    .container {
      padding: 20px 30px;
      .main-file {
        width: 100%;
        background: #fafafa;
        border: 1px solid #e5e5e5;
        .file-container {
          padding: 26px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .file-left {
            display: flex;
            align-items: center;
            column-gap: 20px;
            .file-ico {
              width: 41px;
              height: 48px;
            }
            .file-name-box {
              display: flex;
              align-items: center;
              column-gap: 10px;
              .name {
                color: #1a1a1a;
                font-size: 18px;
                font-weight: bold;
              }
              .type {
                background: rgba(63, 122, 202, 0.1);
                border-radius: 13px;
                color: #3f7aca;
                font-size: 14px;
                text-align: center;
                padding: 3px 15px;
              }
            }
          }
          .down-btn {
            width: 32px;
            height: 32px;
            background-image: url("../../../assets/images/icon-download-btn.png");
            cursor: pointer;
            background-position: center;
            background-size: cover;
          }
        }
      }
      .main-info {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        margin-top: 30px;
        .info-item {
          display: flex;
          align-items: center;
          column-gap: 20px;
          font-size: 14px;
          .info-label {
            color: #808080;
          }
          .info-value {
            color: #1a1a1a;
          }
        }
      }
      .part-title {
        width: 100%;
        display: flex;
        align-items: center;
        column-gap: 14px;
        margin-top: 50px;
        .title-name {
          color: #1a1a1a;
          font-size: 16px;
          font-weight: bold;
        }
        .title-line {
          flex: 1;
          background: #ebebeb;
          height: 1px;
        }
      }
      .file-list-box {
        width: 100%;
        padding: 20px;
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        .file-list-item {
          width: 100%;
          background: #fafafa;
          border-radius: 5px;
          border: 1px solid #e0e0e0;
          .list-item-container {
            padding: 8px 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .list-item-left {
              display: flex;
              align-items: center;
              column-gap: 13px;
              .item-file-icon {
                width: 31px;
                height: 36px;
              }
              .item-file-name {
                color: #1d1d1d;
                font-size: 14px;
              }
            }
            .list-item-right {
              color: #666666;
              font-size: 12px;
              cursor: pointer;
              margin-right: 10px;
              &:hover {
                color: #5d8eec;
              }
            }
          }
        }
      }
    }
  }
  .detail-bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 20px;
    flex-shrink: 0;
    border-top: 1px solid #e0e0e0;
    padding: 10px 0;
    .cancel-btn {
      background: #ffffff;
      border-radius: 19px;
      border: 1px solid #e5e5e5;
      color: #333333;
      font-size: 14px;
      padding: 12px 46px;
      cursor: pointer;
    }
    .confirm-btn {
      background: #000000;
      color: #ffffff;
      border-radius: 19px;
      font-size: 14px;
      padding: 12px 31px;
      cursor: pointer;
    }
  }
}
</style>
